import { InspectorPanelSettingsFields } from "../InspectorPanelSettingsFields"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { selectUserLocationShareById } from "features/entity-caching/flights/selectors"
import { ButtonPrimary } from "@nova/component-btn"
import { openPlayback } from "plugins/shared/playback/state/slice"
import { clearSelection } from "panels/content/side-panel/slice.new"
import * as Icons from "@nova/component-icons"

export const InspectorPanelUserLocationShareLayer = ({ id }: { id: string }) => {
    const dispatch = useAppDispatch()
    const share = useAppSelector(selectUserLocationShareById(id))
    if (!share) return null

    return (
        <InspectorPanelSettingsFields shouldShowTopBorder={false}>
            {!share.live && (
                <ButtonPrimary
                    title="Replay"
                    RightIcon={Icons.PlayCircle}
                    onClick={() => {
                        dispatch(openPlayback({ id, type: "locationShare" }))
                        dispatch(clearSelection())
                    }}
                />
            )}
        </InspectorPanelSettingsFields>
    )
}
